import { render } from "./AlwaysOpenAccordion.vue?vue&type=template&id=d692f4b4"
import script from "./AlwaysOpenAccordion.vue?vue&type=script&lang=js"
export * from "./AlwaysOpenAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__